import type React from 'react';
import { resolveInstructionSegments } from './instruction-segments';
import type { IngredientForPlaceholder } from './placeholders';
import type { UnitSystem } from './unit-display';

/**
 * Resolve a step instruction into React nodes, wrapping every ingredient
 * mention in a `<mark>` (styled by the caller via `markClassName`) and
 * resolving everything else to plain text. Shared by the recipe-detail step
 * list and cook mode.
 *
 * The walk itself lives in `resolveInstructionSegments` because the Cast
 * receiver needs the same split as data rather than as React (#972). This
 * function is the React renderer over it, nothing more.
 */
export function resolveInstructionNodes(
  text: string,
  ingredients: IngredientForPlaceholder[],
  selectedServings: number,
  baseServings: number,
  locale: 'en' | 'de',
  unitSystem: UnitSystem,
  markClassName: string,
): React.ReactNode[] {
  const segments = resolveInstructionSegments(
    text,
    ingredients,
    selectedServings,
    baseServings,
    locale,
    unitSystem,
  );

  let markKey = 0;
  return segments.map((segment) =>
    segment.ingredient ? (
      <mark key={`mark-${markKey++}`} className={markClassName}>
        {segment.text}
      </mark>
    ) : (
      segment.text
    ),
  );
}
